import React from 'react';
import Modal from '../Components/Interactive/Modal/Modal';
export class ModalManager {
    setModal;
    onCloseModal;
    registerSetState(setModal) {
        this.setModal = setModal;
    }
    showModal(modal) {
        if (!this.setModal) {
            throw new Error('Could not show modal, no modal container has been registered. Ensure you have placed a `ModalContainer` in your tree.');
        }
        this.setModal(modal);
    }
    createAndShowModal(props) {
        this.onCloseModal = props.onClose;
        const modal = React.createElement(Modal, { ...props, close: () => this.hideModal() });
        this.showModal(modal);
    }
    hideModal() {
        if (!this.setModal) {
            return;
        }
        this.onCloseModal?.();
        this.setModal(undefined);
    }
}
const modalManager = new ModalManager();
export default modalManager;
//# sourceMappingURL=ModalManager.js.map